export default __webpack_public_path__ + "static/media/logoBPW.bcc4812c.png";